module.exports = __webpack_public_path__ + "static/img/3.8053375.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/3.png
// module id = DaCE
// module chunks = 0